// Mock data for Healing-Women website

export const mockData = {
  siteInfo: {
    name: 'Healing-Women',
    tagline: 'Explant Surgery Specialist • Women\'s Health Coach • Author of Explant',
    phone: '+1 604 780 1466',
    location: 'British Columbia, Canada',
    email: 'info@healing-women.com',
    socialMedia: {
      facebook: 'https://www.facebook.com/105386384752435',
      instagram: 'https://www.instagram.com/lindseyocean/',
      linkedin: 'https://www.linkedin.com/in/lindsey-mayr-26528113b',
      tiktok: 'https://www.tiktok.com/@explanthealer',
      youtube: 'https://www.youtube.com/@healingwomen'
    },
    whatsapp: 'https://wa.me/16047801466'
  },

  sessions: [
    {
      id: '1',
      name: 'Initial Consultation',
      duration: '60 minutes',
      price: 150,
      description: 'A comprehensive first session to understand your journey and create a personalized healing plan.'
    },
    {
      id: '2',
      name: 'Explant Preparation Session',
      duration: '90 minutes',
      price: 200,
      description: 'Specialized guidance for women preparing for explant surgery, covering physical and emotional preparation.'
    },
    {
      id: '3',
      name: 'Post-Surgery Recovery Support',
      duration: '60 minutes',
      price: 150,
      description: 'Support and guidance through your recovery journey after explant surgery.'
    },
    {
      id: '4',
      name: 'Healing Package (5 Sessions)',
      duration: '5 x 60 minutes',
      price: 650,
      description: 'A comprehensive package of 5 sessions for ongoing support throughout your healing journey.'
    }
  ],

  book: {
    id: 'book-1',
    title: 'Explant',
    author: 'Lindsey Mayr',
    price: 29.99,
    description: 'A comprehensive guide for women navigating breast implant illness and the explant journey.',
    coverImage: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?w=800&h=1200&fit=crop',
    features: [
      'Personal stories and experiences',
      'Medical insights on breast implant illness',
      'Step-by-step explant preparation guide',
      'Recovery and healing protocols',
      'Emotional support strategies'
    ]
  },

  faqs: [
    {
      id: '1',
      question: 'What is Breast Implant Illness (BII)?',
      answer: 'Breast Implant Illness (BII) is a collection of symptoms that can occur in individuals with breast implants. These symptoms may include fatigue, cognitive issues, joint and muscle pain, and various autoimmune-like conditions. Every woman\'s experience is unique, and I\'m here to support you through understanding and healing from BII.'
    },
    {
      id: '2',
      question: 'How can coaching help with explant surgery?',
      answer: 'Coaching provides emotional support, practical preparation strategies, and guidance throughout your explant journey. I help you prepare mentally and physically for surgery, navigate the healthcare system, and support your recovery process. My personal experience and specialized knowledge in this area allows me to offer unique, compassionate guidance.'
    },
    {
      id: '3',
      question: 'What can I expect from a coaching session?',
      answer: 'Each session is tailored to your specific needs and stage of your journey. We\'ll discuss your symptoms, concerns, and goals. I provide practical tools, emotional support, and evidence-based guidance. Sessions are conducted in a safe, non-judgmental space where you can freely express your feelings and concerns.'
    },
    {
      id: '4',
      question: 'Do you work with women internationally?',
      answer: 'Yes! I work with women all over the world through online video sessions. Healing and support know no boundaries, and I\'m committed to being accessible to women wherever they are on their journey.'
    },
    {
      id: '5',
      question: 'How long does the healing process take?',
      answer: 'Every woman\'s healing journey is unique. Some women experience improvement within weeks, while others may take months or longer. The important thing is that healing is possible, and I\'m here to support you every step of the way, at your own pace.'
    }
  ],

  downloads: [
    {
      id: '1',
      title: 'Explant Preparation Checklist',
      description: 'A comprehensive checklist to help you prepare for your explant surgery.',
      fileType: 'PDF',
      size: '2.4 MB'
    },
    {
      id: '2',
      title: 'BII Symptom Tracker',
      description: 'Track your symptoms and progress throughout your healing journey.',
      fileType: 'PDF',
      size: '1.8 MB'
    },
    {
      id: '3',
      title: 'Post-Surgery Recovery Guide',
      description: 'Essential tips and strategies for optimal recovery after explant surgery.',
      fileType: 'PDF',
      size: '3.1 MB'
    },
    {
      id: '4',
      title: 'Wellness Journal Template',
      description: 'A guided journal template to support your healing journey.',
      fileType: 'PDF',
      size: '2.0 MB'
    }
  ],

  blogPosts: [
    {
      id: '1',
      title: 'My Journey Through Breast Implant Illness',
      excerpt: 'Sharing my personal story of discovering BII and finding the path to healing.',
      content: 'Full blog post content here...',
      author: 'Lindsey Mayr',
      date: '2024-12-15',
      image: 'https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=1200&h=600&fit=crop',
      category: 'Personal Story'
    },
    {
      id: '2',
      title: 'Understanding the Symptoms of BII',
      excerpt: 'A comprehensive guide to recognizing and understanding breast implant illness symptoms.',
      content: 'Full blog post content here...',
      author: 'Lindsey Mayr',
      date: '2024-12-10',
      image: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&h=600&fit=crop',
      category: 'Health & Wellness'
    },
    {
      id: '3',
      title: 'Preparing for Your Explant Surgery: What You Need to Know',
      excerpt: 'Essential tips and guidance for women preparing to have their breast implants removed.',
      content: 'Full blog post content here...',
      author: 'Lindsey Mayr',
      date: '2024-12-05',
      image: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=1200&h=600&fit=crop',
      category: 'Explant Journey'
    }
  ],

  testimonials: [
    {
      id: '1',
      name: 'Sarah M.',
      text: 'Lindsey\'s guidance through my explant journey was invaluable. She understood exactly what I was going through and provided both emotional and practical support.',
      rating: 5
    },
    {
      id: '2',
      name: 'Jennifer K.',
      text: 'Working with Lindsey gave me the confidence and knowledge I needed to move forward with my explant surgery. Her support during recovery was life-changing.',
      rating: 5
    },
    {
      id: '3',
      name: 'Michelle T.',
      text: 'I can\'t thank Lindsey enough for her compassionate coaching. She helped me understand my symptoms and guided me toward healing. Truly grateful!',
      rating: 5
    }
  ],

  aboutLindsey: {
    bio: 'I\'m Lindsey Mayr, a women\'s health coach specializing in Breast Implant Illness and explant surgery support. My journey through BII led me to dedicate my life to helping other women navigate this challenging path. As an author, speaker, and certified coach, I combine personal experience with professional expertise to provide compassionate, comprehensive support.',
    image: 'https://customer-assets.emergentagent.com/job_0611684f-3585-4c13-8ded-0605552a5675/artifacts/88szxmlf_IMGL4002.jpg',
    certifications: [
      'Certified Life Coach',
      'Breast Implant Illness Specialist',
      'Published Author',
      'Wellness Advocate'
    ],
    mission: 'My mission is to empower women with knowledge, support, and hope as they navigate breast implant illness and the explant journey. Every woman deserves to feel heard, supported, and confident in her healing journey.'
  }
};
